class Toolbarmobile extends HTMLElement {
  constructor() {
    super();
    if (theme.config.mqlSmall || theme.config.isTouch) this.init();
  }

  init() {
    this.activate();
    this.lastHeight = null;
    this.setHeight();
    window.addEventListener(
      'resize',
      theme.utils.rafThrottle(this.setHeight.bind(this)),
      { passive: true }
    );
  }

  activate() {
    const header = document.querySelector(".header[data-sticky-state='inactive']");
    this.classList.toggle('active', header === null);
  }

  setHeight() {
    const height = `${this.clientHeight}px`;
    if (height === this.lastHeight) return;

    this.lastHeight = height;
    document.body.style.setProperty('--toolbar-mobile-height', height);
  }
}

if (!customElements.get('toolbar-mobile')) {
  customElements.define('toolbar-mobile', Toolbarmobile);
}
